import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/aws.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardAWS from "../components/core/Course/CourseDetailsCardAWS";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                  AWS Certified Solutions Architect (SAA C03) - Associate Certification Training
                </p>
              </div>

              <p className={`text-richblue-500`}>
                With the growing reliance on cloud computing and the need for scalable, secure, and cost-effective solutions, the AWS Certified Solutions Architect (SAA-C03) - Associate Certification has become a globally recognized standard for cloud architecture expertise. This course is meticulously designed to provide professionals with a comprehensive understanding of AWS services, architectural best practices, and cloud solution design principles.<br></br>
                By mastering AWS Solutions Architect methodologies, participants gain the ability to design, deploy, and manage robust cloud infrastructures with precision and efficiency.
              </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardAWS />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s rapidly evolving digital landscape, organizations are increasingly adopting cloud technologies to drive innovation, scalability, and cost efficiency. The growing complexity of cloud architectures and the need for secure, high-performing solutions have made it essential for professionals to master cloud design and implementation best practices."
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The AWS Certified Solutions Architect (SAA-C03) - Associate Certification Training is designed to address these challenges by providing professionals with a comprehensive understanding of AWS services, architectural principles, and cloud solution design. This course equips participants with the knowledge and skills to design, deploy, and manage scalable, secure, and cost-optimized cloud infrastructures. "
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Understand the core concepts and key services of AWS.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Learn the principles of designing scalable and resilient cloud architectures.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Master best practices of AWS Practises.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Explore AWS security features and compliance requirements.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Understand the purpose and use of AWS storage, compute, database, and networking services.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Learn to design high-performing and fault-tolerant systems on AWS.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                  Prepare confidently for the AWS Certified Solutions Architect (SAA-C03) exam.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName={"Module 1: Introduction to AWS and Cloud Architecture"}
                courseList={[
                  "Overview of AWS and its global infrastructure",
                  "Key concepts of cloud computing and architecture",
                  "Benefits of adopting AWS for scalable and secure solutions"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 2: Designing Resilient Architectures"}
                courseList={[
                  "Choosing reliable and resilient storage solutions",
                  "Designing decoupling mechanisms using AWS services",
                  "Creating multi-tier architecture solutions",
                  "Designing high availability and fault-tolerant architectures"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 3: Defining Performant Architectures"}
                courseList={[
                  "Selecting performant storage and databases",
                  "Applying caching mechanisms to improve performance",
                  "Designing solutions for elasticity and scalability",
                  "Optimizing performance using AWS services"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 4: Securing Applications and Architectures"}
                courseList={[
                  "Securing application tiers using AWS security features",
                  "Implementing data security and encryption best practices",
                  "Designing secure networking infrastructure for VPC applications",
                  "Understanding AWS Identity and Access Management (IAM)"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 5: Cost Optimization and Hybrid Architectures"}
                courseList={[
                  "Understanding cost management and pricing models (e.g., On-Demand, Reserved, Spot)",
                  "Designing cost-optimized architectures",
                  "Implementing hybrid IT architectures (e.g., Direct Connect, Storage Gateway)",
                  "Architectural trade-off decisions (e.g., high availability vs. cost)"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 6: AWS Core Services and Implementation"}
                courseList={[
                  "Working with Amazon EC2, S3, and RDS",
                  "Using AWS Elastic Beanstalk and CloudFormation for deployment",
                  "Implementing solutions with AWS OpsWorks and VPC",
                  "Leveraging AWS services for automation and monitoring"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
